// extracted by mini-css-extract-plugin
export var wrapper = "secondScreenHome-module--wrapper--1SVtU";
export var section = "secondScreenHome-module--section--1pl7A";
export var video = "secondScreenHome-module--video--3xuAN";
export var img = "secondScreenHome-module--img--2x9yn";
export var fade = "secondScreenHome-module--fade--w54GQ";
export var text = "secondScreenHome-module--text--1s6i_";
export var translate = "secondScreenHome-module--translate--2FIuI";
export var mouve = "secondScreenHome-module--mouve--oD42Y";
export var image = "secondScreenHome-module--image--3IsL9";